import { UserScopedGrowthBook, GrowthBook } from '@growthbook/growthbook';

const experimentName =
  'ab-all-browse__search-penalize-60-percent-or-higher-discount';

export function getBrowseExperimentVariant(
  gb?: UserScopedGrowthBook | GrowthBook
): string {
  if (!gb) {
    return 'none';
  }
  return gb.getFeatureValue(experimentName, 'none');
}
